import { EMPTY_FIELD } from 'constants/emptyField';

import { useRecordModal } from 'hooks/useRecordModal';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Chip } from 'shared/mui/Chips';
import { Link } from 'shared/mui/Link/Link';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField } from 'shared/react-admin/Fields';
import { ProviderShowDialog } from 'shared/widgets/ProviderShowDialog/ProviderShowDialog';
import { Gateway } from 'types/embedded/gateway';
import { Provider } from 'types/embedded/provider';

import { GatewayStatusChipField } from './GatewayStatusChipField';

type Props = {
  onProviderClose?: () => void;
  onProviderOpen?: () => void;
};

export const GatewaysShowChipFields: React.FC<Props> = ({ onProviderClose, onProviderOpen }) => {
  const translate = useTypedTranslate();

  const {
    record: provider,
    handleCloseRecordModal: handleCloseProviderModal,
    openRecordModal: openProviderModal,
    handleOpenRecordModal: handleOpenProviderModal,
  } = useRecordModal<Provider>();

  return (
    <Stack direction="row" flexWrap="wrap" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: Gateway) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <FunctionField
        render={(record: Gateway) => (
          <Chip label={`${translate('app.table.name')}: ${record?.name}`} size="small" />
        )}
      />
      <FunctionField
        render={(record: Gateway) => (
          <Chip
            label={
              <Typography fontSize={13}>
                {translate('app.table.provider')}:{' '}
                <Link>{record?.provider?.name || EMPTY_FIELD}</Link>
              </Typography>
            }
            onClick={() => {
              handleOpenProviderModal(record.provider);
              onProviderOpen && onProviderOpen();
            }}
            size="small"
          />
        )}
      />
      <FunctionField
        render={(record: Gateway) => (
          <Chip
            label={`${translate('app.table.direction')}: ${record?.direction?.description === 'Все направления' ? 'Пополнение, Вывод' : record?.direction?.description}`}
          />
        )}
      />
      <GatewayStatusChipField />
      {/** TODO: ProviderShowDialog нужно вынести наружу из GatewaysShowChipFields
       Проблема: компонент отвечает за отображение чипов, но также
       управляет состоянием модалки провайдера (useRecordModal) и рендерит
       сам диалог - это нарушает принцип единственной ответственности.

       Решение: поднять useRecordModal и <ProviderShowDialog> в родительский
       компонент (GatewaysShow или аналог), передавать в GatewaysShowChipFields
       только handleOpenProviderModal как проп — колбэки onProviderOpen/onProviderClose
       тогда тоже станут не нужны.
       */}
      {provider && (
        <ProviderShowDialog
          onClose={() => {
            handleCloseProviderModal();
            onProviderClose && onProviderClose();
          }}
          open={openProviderModal}
          provider={provider}
        />
      )}
    </Stack>
  );
};
